import { useCurrentUser } from '@centered/firebase'
import { Group } from '@centered/types'
import { GetStaticProps } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import AvailableIntegrations from '../components/landing-page/AvailableIntegrations'
import ChooseYourCoach from '../components/landing-page/ChooseYourCoach'
import CommunityLeaderboard from '../components/landing-page/CommunityLeaderboard'
import CrushYourWork from '../components/landing-page/CrushYourWork'
import FeatureList from '../components/landing-page/FeatureList'
import FeaturedPublications from '../components/landing-page/FeaturedPublications'
import HeroSection from '../components/landing-page/HeroSection'
import LaserFocus from '../components/landing-page/LaserFocus'
import OrgUsers from '../components/landing-page/OrgUsers'
import PhoneDistraction from '../components/landing-page/PhoneDistraction'
import Pricing from '../components/landing-page/Pricing'
import SocialCards from '../components/landing-page/SocialCards'
import SEOMetaTags from '../components/seo/SEOMetaTags'
import Footer from '../components/shared/Footer'
import Header from '../components/shared/Header'
import { fetchLandingPageProps } from '../lib/fetchLandingPageProps'
import { SocialPost } from '../lib/fetchSocialMediaPosts'

type IndexProps = {
  socialPosts: SocialPost[]
  coaches: Group[]
  disableMetaTags?: boolean
  group?: Group
}

export default function LandingPage({
  coaches,
  disableMetaTags = false,
  group,
}: IndexProps): JSX.Element {
  // 🚨🚨🚨: It is vitally important that we don't render the the home page conditionally
  // If we do, then SSR will render an empty page which means google won't be able to crawl our home page

  const router = useRouter()
  const { currentUser } = useCurrentUser()
  useEffect(() => {
    if (currentUser?.id) {
      router.replace('/app')
    }
  }, [currentUser?.id])

  return (
    <main className="overflow-x-hidden">
      <style jsx global>{`
        body {
          background-color: #101010;
          color: white;
        }
      `}</style>

      <style jsx>{`
        .gradient-section {
          background: linear-gradient(
            52.39deg,
            rgba(39, 39, 39, 0.6) 0%,
            rgba(30, 30, 30, 0.6) 100%
          );
        }

        .black-bg {
          background: black;
        }
      `}</style>

      {!disableMetaTags && <SEOMetaTags title="Sukha – Feel great.  Today." />}

      <Header alwaysShowSignupButton={false} />

      <HeroSection groups={coaches} />

      <div className="black-bg">
        <CrushYourWork />
        <ChooseYourCoach coaches={coaches} />
      </div>

      <CommunityLeaderboard group={group} />

      <FeatureList />

      <PhoneDistraction />

      <div className="gradient-section py-20">
        <AvailableIntegrations />

        <SocialCards />
      </div>

      <OrgUsers />

      <div className="gradient-section">
        <Pricing />

        <LaserFocus />

        <FeaturedPublications />
      </div>

      <Footer />
    </main>
  )
}

export const getStaticProps: GetStaticProps<IndexProps> = async () => {
  const props = await fetchLandingPageProps()

  return {
    props,
  }
}
